/**
 * Created by tpetridis on 23/2/2017.
 */
export default {
  // User object will let us check authentication status
  showHideModalForHomePage(vm) {
    /* eslint-disable */
    console.log('Inside Generic modals.js /showHideModal HomePage method ');
    vm.$nextTick(() => {
      console.log('ShowHideModal Generic Open HomePage ');
      $('.modal,.modal-overlay,.overlay').fadeIn(200);
      $("body").addClass("modal-open");
      // show/hide modal
      $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        vm.storeModalForHomePage(null);
        console.log(`ShowHideModal Generic Hide For HomePage: ${vm.$store.state.common.userDetails.subscribed} + ${vm.$root._route.fullPath}`);
        if (vm.$store.state.common.userDetails.subscribed && vm.$root._route.fullPath === '/home/settings') {
          vm.$router.push('/home');
          console.log('ShowHideModal Generic Hide For HomePage inside root to home');
        }
      });
    });
    /* eslint-enable */
  },
  showHideModalInStore(vm) {
    /* eslint-disable */
    vm.$nextTick(() => {
      $('.modal,.modal-overlay,.overlay').fadeIn(200);
      $("body").addClass("modal-open");
      // show/hide modal
      $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        vm.storeModalForStore(null);
        vm.storeModalForHomePage(null);
      });
    });
    /* eslint-enable */
  },
  showHideModalGeneric(vm) {
    /* eslint-disable */
    console.log('Inside Generic modals.js /showHideModal method ');
    vm.$nextTick(() => {
      console.log('ShowHideModal Generic Open ');
      $('.modal,.modal-overlay,.overlay').fadeIn(200);
      $("body").addClass("modal-open");
      // show/hide modal
      $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        console.log('ShowHideModal Generic Hide ');
      });
    });
    /* eslint-enable */
  },
  showHideModal(vm) {
    /* eslint-disable */
    console.log('Inside Generic modals.js /showHideModal method ');
    vm.$nextTick(() => {
      console.log('ShowHideModal Generic Open ');
      $('.modal,.modal-overlay,.overlay').fadeIn(200);
      $("body").addClass("modal-open");
      // show/hide modal
      $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        console.log('ShowHideModal Generic Hide ');
        vm.storeModalForHomePage(null);
      });
    });
    /* eslint-enable */
  },
  hideModal(vm) {
    /* eslint-disable */
    // hide modal
    $(".popup_box").fadeOut(200);
    $(".overlay").fadeOut(200);
    $('.modal, .modal-overlay').fadeOut();
    $("body").removeClass("modal-open");
    console.log('ShowHideModal Generic Hide For hideModal/modal');
    vm.storeModalForHomePage(null);
    /* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./src/common/modals.js